/**
 * Snippet Service - Servicio de fragmentos PDF
 */

import { ApiServiceBase } from '../core/ApiService';
import type { PDFSnippet } from '../types/common';

export class SnippetService extends ApiServiceBase {
  /**
   * Obtiene todos los fragmentos PDF del usuario
   */
  async getPDFSnippets(options?: {
    document_id?: string;
    tags?: string[];
    include_image?: boolean;
  }): Promise<PDFSnippet[]> {
    const params = new URLSearchParams();
    if (options?.document_id) params.append('document_id', options.document_id);
    if (options?.tags) params.append('tags', options.tags.join(','));
    if (options?.include_image !== undefined) params.append('include_image', String(options.include_image));

    return this.request(`/pdf-snippets?${params.toString()}`, {
      method: 'GET',
    }).then((data: any) => data.snippets || []);
  }

  /**
   * Obtiene un fragmento PDF específico (con imagen completa)
   */
  async getPDFSnippet(snippetId: string): Promise<PDFSnippet> {
    return this.request(`/pdf-snippets/${snippetId}`, {
      method: 'GET',
    }).then((data: any) => data.snippet);
  }

  /**
   * Crea un nuevo fragmento PDF
   */
  async createPDFSnippet(data: {
    document_id: string;
    title: string;
    notes?: string;
    tags?: string[];
    page_number: number;
    coordinates: { x: number; y: number; width: number; height: number; scale?: number };
    snippet_type: 'image' | 'text';
    image_data?: string;
    text_content?: string;
    context_text?: string;
  }): Promise<PDFSnippet> {
    return this.request('/pdf-snippets', {
      method: 'POST',
      body: JSON.stringify(data),
    }).then((result: any) => result.snippet);
  }

  /**
   * Actualiza un fragmento PDF
   */
  async updatePDFSnippet(snippetId: string, data: {
    title?: string;
    notes?: string;
    tags?: string[];
  }): Promise<PDFSnippet> {
    return this.request(`/pdf-snippets/${snippetId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }).then((result: any) => result.snippet);
  }

  /**
   * Elimina un fragmento PDF
   */
  async deletePDFSnippet(snippetId: string): Promise<void> {
    await this.request(`/pdf-snippets/${snippetId}`, {
      method: 'DELETE',
    });
  }
}
